import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

export interface LoadingDialogData {
  message?: string;
}

@Component({
  selector: 'app-loading-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule, MatProgressSpinnerModule],
  template: `
    <div class="loading-modal" mat-dialog-content>
      <p cdkFocusInitial class="message" tabindex="-1">{{ data?.message || ('dialog.loading' | translate) }}</p>
      <mat-progress-spinner mode="indeterminate" diameter="44"></mat-progress-spinner>
    </div>
  `,
  styles: [
    `
      .loading-modal {
        min-width: 12rem;
        min-height: 10rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--rss-padding);
        text-align: center;
        padding: 1rem 2rem;
      }

      .message {
        margin: 0;
      }
    `
  ]
})
export class LoadingModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: LoadingDialogData | null) {}
}
